<template>
    <div class="error-content">
        <div class="error-content__container">
            <div class="error-content__inner">
                <h1 class="error-content__error">
                    {{ brandSettings['error-page_error-code'] }}
                </h1>

                <h2 class="error-content__title u-heading-3">
                    {{ brandSettings['error-page_title'] }}
                </h2>
            </div>

            <div class="error-content__content">
                <!-- eslint-disable vue/no-v-html -->
                <div
                    v-if="brandSettings['error-page_text']"
                    class="error-content__text"
                    v-html="brandSettings['error-page_text']"
                ></div>

                <WatsonAtomImage
                    v-if="brandSettings['error-page_illustration']"
                    :content="brandSettings['error-page_illustration']"
                    class="error-content__illustration"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

import WatsonAtomImage from '@atoms/image/watson-atom-image.vue';

defineProps({
    brandSettings: {
        type: Object,
        required: true,
    },
});
</script>

<style lang="scss">
@use 'watson-organism-error-content';
</style>
